import { createContext, PropsWithChildren } from 'react';
import { theme as wllTheme } from '@/core/App/theme';
import { ThemeProvider } from 'react-admin';
import { LocalStorageProvider } from '@/contexts/LocalStorage';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from '@/state/store';
import MessagingBusProvider from '@/contexts/MessagingBusContext';

const GlobalContext = createContext({});

export default function GlobalContextProvider({ children }: PropsWithChildren) {
  return (
    <GlobalContext.Provider value={{}}>
      <ThemeProvider theme={wllTheme}>
        <LocalStorageProvider>
          <ReduxProvider store={store}>
            <MessagingBusProvider>{children}</MessagingBusProvider>
          </ReduxProvider>
        </LocalStorageProvider>
      </ThemeProvider>
    </GlobalContext.Provider>
  );
}
